import "./Dashboard.scss";
import "react-datepicker/dist/react-datepicker.css";
import { useUser } from "../context/UserContext";
import { Typography } from "antd";

import { hasRoleAccess } from "../utils/constants";
import StockRecord from "../components/Sections/StockRecord";
import TeamLeaveRequests from "../components/Sections/TeamLeaveRequests";
import PendingCancelLeaveRequests from "../components/Sections/PendingCancelLeaveRequests";
import PDFGenerationDebugModal from "../components/Modals/PDFGenerationDebugModal";

const Dashboard = () => {
  const { authUser, roles } = useUser();
  const showPdfDebug = true;

  return (
    <div className="page-container">
      <div className="flex items-center justify-between gap-4 mb-4">
        <Typography.Title level={2} className="!m-0">
          Welcome {authUser?.name}!
        </Typography.Title>
        {showPdfDebug && <PDFGenerationDebugModal />}
      </div>

      {hasRoleAccess(roles, ["ADMIN", "HR", "MANAGER"]) && (
        <TeamLeaveRequests />
      )}

      {hasRoleAccess(roles, ["ADMIN", "MANAGER"]) && (
        <PendingCancelLeaveRequests />
      )}

      {hasRoleAccess(roles, ["ADMIN", "MANAGER", "HR"]) && <StockRecord />}
    </div>
  );
};

export default Dashboard;
